// components/StatusBadge.jsx
import React from 'react';
import { CheckCircle, Clock, XCircle, AlertCircle, MinusCircle } from 'lucide-react';

const StatusBadge = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'active':
        return {
          label: 'Active',
          icon: CheckCircle,
          className: 'bg-emerald-50 text-emerald-700 border-emerald-200'
        };
      case 'trial':
        return {
          label: 'Trial',
          icon: Clock,
          className: 'bg-blue-50 text-blue-700 border-blue-200'
        };
      case 'expired':
        return {
          label: 'Expired',
          icon: XCircle,
          className: 'bg-rose-50 text-rose-700 border-rose-200'
        };
      case 'cancelled':
        return {
          label: 'Cancelled',
          icon: XCircle,
          className: 'bg-slate-50 text-slate-600 border-slate-200'
        };
      case 'suspended':
        return {
          label: 'Suspended',
          icon: AlertCircle,
          className: 'bg-red-50 text-red-700 border-red-200'
        };
      case 'pending':
        return {
          label: 'Pending',
          icon: Clock,
          className: 'bg-amber-50 text-amber-700 border-amber-200'
        };
      case 'none':
      default:
        return {
          label: 'No Plan',
          icon: MinusCircle,
          className: 'bg-slate-50 text-slate-400 border-slate-200'
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border ${config.className}`}>
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
};

export default StatusBadge;